import React from 'react'

// The context for use by the Providers and hook
const EFSDataContext = React.createContext({})

export default EFSDataContext
